import clsx from 'clsx';
import React from 'react';
import { BiSearch } from 'react-icons/bi';

import NeonBorder from '../NeonBorder/NeonBorder';

interface ISearchField extends React.HTMLAttributes<HTMLInputElement> {
  placeholder?: string;
  className?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const SearchField = ({ className, ...rest }: ISearchField) => {
  return (
    <div className={clsx('relative', className)}>
      <NeonBorder className="rounded-4xl" />
      <div className="relative w-full rounded-4xl bg-slate-50/20">
        <BiSearch className="absolute inset-y-0 left-6 my-auto h-6 w-6 text-cream" />
        <input
          type="search"
          className={clsx(
            'relative z-10 block w-full appearance-none rounded-4xl bg-transparent py-4 pl-16 pr-7 text-cream focus:outline-cream'
          )}
          placeholder="Search"
          {...rest}
        />
      </div>
    </div>
  );
};

export default SearchField;
